import React, { useState, useEffect } from "react";
import { RiTodoLine } from "react-icons/ri";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { PiDotsSixVerticalBold } from "react-icons/pi";
import { BiTimeFive } from "react-icons/bi";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Style/Dashboard.css";

import { Checkbox } from "@mui/material";

// FIX: this component was entirely static before — no state, no input
// field, and the "Add Item" button had no onClick handler at all, which is
// why nothing happened when clicking it. The 4 todo rows were hardcoded
// JSX, and the checkbox strike-through logic used document.getElementById
// on ids ("check"/"txt") that were duplicated across every row, so it could
// only ever affect the first item regardless of which checkbox was clicked.
//
// This version is fully state-driven: an input + Add Item button that
// validates non-empty text, appends to state (so it renders immediately,
// no refresh needed), and persists to localStorage so items survive a
// page reload. NOTE: there's no confirmed backend endpoint for todos in
// this codebase — if one exists, swap the localStorage read/write below
// for the real API calls so items persist server-side, not just locally.

const STORAGE_KEY = "crm_todo_list_items";

const loadInitialTodos = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch {
    // fall through to defaults below
  }
  // Sensible starting content, replacing the old hardcoded rows.
  return [
    { id: 1, text: "Design a nice Theme", completed: false, minutesAgo: 2 },
  ];
};

const TodoList = () => {
  const [todos, setTodos] = useState(loadInitialTodos);
  const [newTaskText, setNewTaskText] = useState("");

  // Persist to localStorage any time the list changes.
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(todos));
    } catch {
      // localStorage can fail (private mode, quota) — non-fatal, list
      // still works for the current session.
    }
  }, [todos]);

  const handleAddItem = () => {
    const trimmed = newTaskText.trim();
    if (!trimmed) {
      toast.error("Task cannot be empty.");
      return;
    }
    const newTodo = {
      id: Date.now(),
      text: trimmed,
      completed: false,
      minutesAgo: 0,
    };
    setTodos((prev) => [newTodo, ...prev]);
    setNewTaskText("");
    toast.success("Task added successfully");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddItem();
    }
  };

  const handleToggle = (id) => {
    setTodos((prev) =>
      prev.map((t) => (t.id === id ? { ...t, completed: !t.completed } : t))
    );
  };

  const handleDelete = (id) => {
    setTodos((prev) => prev.filter((t) => t.id !== id));
    toast.success("Task removed");
  };

  return (
    <>
      <div className="card cont">
        <div className="card-header d-flex justify-content-between">
          <div className="mt-2">
            {" "}
            <h4
              style={{
                color: "gray",
                "font-size": "1rem",
                "font-weight": "600",
              }}
              className="card-title"
            >
              {" "}
              <RiTodoLine className="mr-2" />
              Todo List
            </h4>
          </div>
          <div className="d-flex" style={{ textDecoration: "none" }}>
            <ul className="d-flex">
              <li>
                <a href="#" className="page-link">
                  {" "}
                  <AiOutlineDoubleLeft />{" "}
                </a>
              </li>
              <li>
                <a href="#" className="page-link">
                  1
                </a>
              </li>
              <li>
                <a href="#" className="page-link">
                  2
                </a>
              </li>
              <li>
                <a href="#" className="page-link">
                  3
                </a>
              </li>
              <li>
                <a href="#" className="page-link">
                  <AiOutlineDoubleRight />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="card-body">
          {/* New task input */}
          <div className="d-flex m-2 mb-3" style={{ gap: "0.5rem" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Enter a new task..."
              value={newTaskText}
              onChange={(e) => setNewTaskText(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button
              className="btn btn-primary"
              style={{ whiteSpace: "nowrap" }}
              onClick={handleAddItem}
            >
              Add Item
            </button>
          </div>

          {todos.length === 0 ? (
            <p className="text-muted text-center m-3">
              No tasks yet. Add one above to get started.
            </p>
          ) : (
            todos.map((todo) => (
              <div
                key={todo.id}
                className="d-flex m-2 justify-content-between"
              >
                <div className="todo">
                  <PiDotsSixVerticalBold
                    style={{ fontSize: "25px" }}
                    className=""
                  />{" "}
                  <Checkbox
                    checked={todo.completed}
                    onChange={() => handleToggle(todo.id)}
                  />
                  <span
                    className="text mt-2 ml-2"
                    style={{
                      textDecoration: todo.completed ? "line-through" : "none",
                      color: todo.completed ? "gray" : undefined,
                    }}
                  >
                    {" "}
                    <b style={{ color: "darkgray" }}>{todo.text}</b>
                  </span>{" "}
                  <small className="badge badge-danger text-white mt-2 mb-3 ml-2">
                    {" "}
                    <BiTimeFive /> {todo.minutesAgo} mins
                  </small>{" "}
                </div>
                <span className="pr-2 edit d-flex" style={{ gap: "0.5rem" }}>
                  <h5
                    style={{ color: "red", cursor: "pointer", margin: 0 }}
                    title="Edit"
                  >
                    <FiEdit />
                  </h5>
                  <h5
                    style={{ color: "#6c757d", cursor: "pointer", margin: 0 }}
                    title="Delete"
                    onClick={() => handleDelete(todo.id)}
                  >
                    <FiTrash2 />
                  </h5>
                </span>
              </div>
            ))
          )}
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default TodoList;